module.exports = __webpack_public_path__ + "img/thumbnail_ArcticFox_f_normal.447bc70d.png";